import type { OptionValue } from '@tempmee/core';
import { useMemo } from 'react';
import { toParkingTypeOptions } from '~/constants/officeProfileOptions';
import { useGetMetadata } from '~/domain/Metadata';

/** The parking-type picker's options: the metadata's `parkingTypes`, or the fallback until they load. */
export const useParkingTypeOptions = (): OptionValue<string>[] => {
  const parkingTypesFromMetadata = useGetMetadata().data?.parkingTypes;

  return useMemo(() => toParkingTypeOptions(parkingTypesFromMetadata), [parkingTypesFromMetadata]);
};
